import FirstLayer from "../Components/Coursework/FirstLayer";

const Coursework = () => {
    return (
        <FirstLayer/>
    )
}

export default Coursework